(function () {
    angular.module('far.search').factory('Search', search);

    function search($resource) {
        return $resource('/api/search', {}, {
            search: {
                method: 'GET'
            }
        });
    }
})();
